import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'
import { industryData } from '@/assets/formats/industryData'
import { jobTypeData } from '@/assets/formats/jobTypeData'
import PersonalRequestFields from '@/components/formats/RirekishoParts/PersonalRequestFields.vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import {
  useRirekishoFormatData,
  type RirekishoExampleSentence,
  type RirekishoExampleSentences
} from '@/composables/format-edit/useRirekishoFormatData'
import { useRirekishoRequestAi } from '@/composables/format-edit/useRirekishoRequestAi'
import type { BasicData } from '@/utils/format-edit/basicData'


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoRequestsCard',
  props: {
    currentCardId: null,
    formatId: null,
    basicData: null,
    previewErrors: null,
    exampleSentences: null,
    variant: { default: 'full' }
  },
  emits: ["update-basic-data"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update-basic-data', payload: Partial<BasicData>): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { currentCardId?: string, formatId?: string, basicData: BasicData, previewErrors: Record<string, string>, exampleSentences?: RirekishoExampleSentences, variant: 'full' | 'salary' };





const formatData = useRirekishoFormatData()
const exampleVisible = ref(false)
const isSalaryVariant = computed(() => props.variant === 'salary')

const {
  requestAiGenerated,
  requestAiLoading,
  requestAiError,
  bizreachIndustryGroups,
  bizreachJobCategoryGroups,
  getIndustryName,
  getJobCategoryName,
  runAutoRequestIfNeeded
} = useRirekishoRequestAi({
  formatData,
  basicData: () => props.basicData,
  emitUpdateBasicData: (payload) => emit('update-basic-data', payload),
  enabled: props.variant !== 'salary'
})

const requestExamples = computed(() => props.exampleSentences?.request || [])

watch(
  () => props.currentCardId,
  (newVal) => {
    if (newVal === 'requests' && !isSalaryVariant.value) {
      runAutoRequestIfNeeded()
    }
  }
)

function onUpdateBasicData(payload: Partial<BasicData>) {
  Object.assign(props.basicData, payload)
  emit('update-basic-data', payload)
}

function onSelectExample(item: RirekishoExampleSentence) {
  formatData.request +=
    item.description
      .replace(/<br>/gi, '\n')
      .replace('OOO', formatData.nowNensyu)
      .replace('XXX', formatData.kibouNensyu) + '\n'
}

return { __sfc: true,props, emit, formatData, exampleVisible, isSalaryVariant, requestAiGenerated, requestAiLoading, requestAiError, bizreachIndustryGroups, bizreachJobCategoryGroups, getIndustryName, getJobCategoryName, runAutoRequestIfNeeded, requestExamples, onUpdateBasicData, onSelectExample, industryData, jobTypeData, PersonalRequestFields, NewRirekishoExampleSentenceDialog }
}

})